import ConfirmationModal from './ConfirmationModal';
export default ConfirmationModal;

export { useConfirmationModal } from './ConfirmationModal.hooks';
export type { UseConfirmationModalProps, ModalStatus } from './ConfirmationModal.hooks';
export type { ConfirmationModalProps } from './ConfirmationModal';
